import type Store from "@ember-data/store";
import Route from "@ember/routing/route";
import type RouterService from "@ember/routing/router-service";
import { service } from "@ember/service";

import type NavigationService from "parog-web/services/navigation";
import type { CompoundSurveyCompletedAndPatient } from "./new-route";

export default class CompoundSurveysEditRoute extends Route {
  @service declare router: RouterService;
  @service declare store: Store;
  @service declare navigation: NavigationService;

  model({
    je_id
  }: {
    je_id: string;
  }): CompoundSurveyCompletedAndPatient | null {
    const surveyCompletedJe = this.store.peekRecord(
      "compound-survey-completed-journal-event",
      je_id
    );

    if (!surveyCompletedJe) return null;

    return { surveyCompletedJe, patient: surveyCompletedJe.patient };
  }

  afterModel(model: CompoundSurveyCompletedAndPatient | null): void {
    if (!model) {
      this.router.transitionTo(
        this.navigation.currentPatientRouteName + ".compound-surveys"
      );
    }
  }
}
